import { twMerge } from 'tailwind-merge'
import { ISection } from '../../../models/ISection'
import Post from '../../components/Post'
import Link from 'next/link';
import SectionTitle from '../../components/SectionTitle';

export default function SectionFour(data: ISection) {
  if (!data?.posts?.length) return null;
  const post1 = data.posts[0];
  const post2 = data.posts[1];
  const post3 = data.posts[2];
  const post4 = data.posts[3];
  const post5 = data.posts[4];
  return (
      <section key={data.internalName}>
      {data.showTitle && data.title ? <SectionTitle title={data.title} href={`/${data.targetSlug}`} target='_self'/> : null}

       <div className='grid grid-cols-1 tablet:grid-cols-2 tablet:grid-rows-[1fr_142.5px_142.5px] desktop:grid-cols-3 desktop:grid-rows-[repeat(4,142.5px)] gap-[24px] h-fit'>
          <Post 
          isLarge
          badge={{mobile: 'image', tablet: 'image', desktop: 'image'}}
          newsType={post1.newsType}
            targetSlug={data.targetSlug} 
            automated={data.automated} 
            targetType={data.targetType} 
            type={post1.type} 
            title={post1.title}
            image={{
              src: post1.image, 
              fill: true, 
              sizes: '100vw', 
              className: 'aspect-[4/3] rounded-tr-[12px] rounded-tl-[12px]',
              alt: post1.imageAlt || '', 
              ...(data.eager ? {priority: true, loading: 'eager'} : {})
            }} 
            category={post1.category} 
            uniqueCode={post1.uniqueCode}
            hide={{category: true}}
            classNames={{
              wrapper: twMerge(
                'tablet:h-full tablet:w-full rounded-[12px] tablet:col-span-full desktop:h-full desktop:col-start-1 desktop:col-end-3 desktop:row-start-1 desktop:row-end-5 desktop:w-full',  
              ),
              image: twMerge('mb-0 desktop:h-fit desktop:aspect-[107/71]'), 
              contentContainer: 'p-[16px] flex-1 flex-shrink-0', 
              title: twMerge('h3 line-clamp-2'), 
            }}
            thumbnail={post1.thumbnail}
          />

            <Post 
            badge={{mobile: 'image', tablet: 'image', desktop: 'image'}}
            newsType={post2.newsType}
            targetSlug={data.targetSlug} 
            automated={data.automated} 
            targetType={data.targetType} 
            type={post2.type} 
            title={post2.title}
            image={{
              src: post2.image, 
              fill: true, 
              sizes: '100vw', 
              className: 'aspect-[4/3] rounded-tr-[12px] rounded-br-[12px]',
              alt: post2.imageAlt || '', 
            }} 
            category={post2.category} 
            uniqueCode={post2.uniqueCode}
            hide={{category: true}}
            classNames={{
              wrapper: twMerge(
                'tablet:h-full tablet:w-fit rounded-[12px] desktop:col-start-3 desktop:col-end-4 flex-row desktop:row-start-1 desktop:row-end-2',
              ),
              image: twMerge('mb-0 aspect-[4/3] w-fit w-[50%] tablet:w-auto'), 
              contentContainer: 'p-[16px] flex-1 flex-shrink-0', 
              title: twMerge('h5'), 
            }}
            thumbnail={post2.thumbnail}
          />

            <Post 
            badge={{mobile: 'image', tablet: 'image', desktop: 'image'}}
            newsType={post3.newsType}
            targetSlug={data.targetSlug} 
            automated={data.automated} 
            targetType={data.targetType} 
            type={post3.type} 
            title={post3.title}
            image={{
              src: post3.image, 
              fill: true, 
              sizes: '100vw', 
              className: 'aspect-[4/3] rounded-tr-[12px] rounded-br-[12px]',
              alt: post3.imageAlt || '', 
            }} 
            category={post3.category} 
            uniqueCode={post3.uniqueCode}
            hide={{category: true}}
            classNames={{
              wrapper: twMerge(
                'tablet:h-full tablet:w-fit rounded-[12px] desktop:col-start-3 desktop:col-end-4 flex-row desktop:row-start-2 desktop:row-end-3',
              ),
              image: twMerge('mb-0 aspect-[4/3] w-fit w-[50%] tablet:w-auto'), 
              contentContainer: 'p-[16px] flex-1 flex-shrink-0', 
              title: twMerge('h5'), 
            }}
            thumbnail={post3.thumbnail}
          />

            <Post 
            badge={{mobile: 'image', tablet: 'image', desktop: 'image'}}
            newsType={post4.newsType}
            targetSlug={data.targetSlug} 
            automated={data.automated} 
            targetType={data.targetType} 
            type={post4.type} 
            title={post4.title}
            image={{
              src: post4.image, 
              fill: true, 
              sizes: '100vw', 
              className: 'aspect-[4/3] rounded-tr-[12px] rounded-br-[12px]',
              alt: post4.imageAlt || '', 
            }} 
            category={post4.category} 
            uniqueCode={post4.uniqueCode}
            hide={{category: true}}
            classNames={{
              wrapper: twMerge(
                'tablet:h-full tablet:w-fit rounded-[12px] desktop:col-start-3 desktop:col-end-4 flex-row desktop:row-start-3 desktop:row-end-4',
              ),
              image: twMerge('mb-0 aspect-[4/3] w-fit w-[50%] tablet:w-auto'), 
              contentContainer: 'p-[16px] flex-1 flex-shrink-0', 
              title: twMerge('h5'), 
            }}
            thumbnail={post4.thumbnail}
          />

            <Post 
            badge={{mobile: 'image', tablet: 'image', desktop: 'image'}}
            newsType={post5.newsType}
            targetSlug={data.targetSlug} 
            automated={data.automated} 
            targetType={data.targetType} 
            type={post5.type} 
            title={post5.title}
            image={{
              src: post5.image, 
              fill: true, 
              sizes: '100vw', 
              className: 'aspect-[4/3] rounded-tr-[12px] rounded-br-[12px]',
              alt: post5.imageAlt || '', 
            }} 
            category={post5.category} 
            uniqueCode={post5.uniqueCode}
            hide={{category: true}}
            classNames={{
              wrapper: twMerge(
                'tablet:h-full tablet:w-fit rounded-[12px] desktop:col-start-3 desktop:col-end-4 flex-row desktop:row-start-4 desktop:row-end-5'
              ),
              image: twMerge('mb-0 aspect-[4/3] w-fit w-[50%] tablet:w-auto'), 
              contentContainer: 'p-[16px] flex-1 flex-shrink-0', 
              title: twMerge('h5'), 
            }}
            thumbnail={post5.thumbnail}
          />

       </div>
       <Link href={`/${data.targetSlug}`} className={twMerge('rounded-[6px] grid place-items-center w-fit px-[12px] h-[36px] cursor-pointer transition-all duration-300 hover:scale-[103%] self-end ml-[24px] desktop:ml-0 bg-gray-100 dark:bg-quaternary')}>
      <span className='text-dark dark:text-white h6'>المزيد</span>
    </Link>

      </section>
  )
}